import { listReadableForAccount } from './common'
import { getRootCollection } from './queries'

export const listShares = () => getRootCollection('shareRegister')

export const listReadableSharesForAccount = listReadableForAccount(listShares)
